import React from 'react';
import { Link } from 'react-router-dom';

const EmptyCart = () => {
  return (
    <React.Fragment>
      <div className='empty-cart'>
        <svg viewBox="0 0 126 128" height="48" width="48">
          <path d="M43.994 18l1.342 9.98h67.757c-.979 6-3.016 19.327-7.243 46.428-.647 4.14-4.695 7.592-8.84 7.592H52.122c-4.162 0-8.285-3.49-8.824-7.502-6.481-48.214-7.005-52.221-7.02-52.332C34.922 13.124 26.695 6 17.55 6H1v10h16.55c4.1 0 8.23 3.612 8.825 7.578 0 0 .508 3.843 7.012 52.224C34.587 84.735 42.99 92 52.122 92H97.01c9.088 0 17.311-7.03 18.72-16.055C124.466 19.923 123.746 24 124.781 18zm-2.992 82a10 10 0 1 0 0 20 10 10 0 1 0 0-20zM103 100a10.002 10.002 0 1 0 0 20.004A10.002 10.002 0 1 0 103 100z" />
        </svg>
        <div className='empty-cart-label'>Your shopping cart is empty</div>
        <Link to="/list" className="es-button primary text-center">
          <span>Start Shopping</span>
        </Link>
      </div>
    </React.Fragment>
  );
};

export default EmptyCart;